/* eslint-disable array-callback-return */
import React, { useEffect, useState,useCallback } from 'react';
import $ from 'jquery'
import { useWallet } from '../WalletProvider';
import swal from "sweetalert"
import ContainerStepThree from "./ContainerStepThree" 
import { fetchTokenDetails, approveTokenBalance,handleApproveTronNft, approveTronBalance, handleApproveNft, fetchTokenABI} from "./airdropHelper"

function ContainerStepTwo(props) {
    const { validData, token, isToken,deflationary,erc1155} = props;
    const [totalTokens, setTotalTokens] = useState();
    const [walletBal, setWalletBal] = useState(0);
    const [tokenBal, setTokenBal] = useState(0);
    const [nftsToDrop, setNftsToDrop] = useState([]);
    const { account, currencyDetails } = useWallet();
    const [showLastStep, setShowLastStep] = useState(false)
    const address = sessionStorage.getItem("address") || account;
    const [rpcWeb3, setRpcWeb3] = useState();
    const [tokenABI, setTokenABI] = useState();
    const[tokendecimal, setTokenDecimal] = useState(18)

    const filterAirdropData = useCallback(
        () =>{
            if(isToken){
                let amount = 0;
                validData.forEach(element => {
                    amount = Number(amount) + Number(element.amount);
                });
                setTotalTokens(amount);
            }else{
                setNftsToDrop([])
                validData.forEach(element => {
                    setNftsToDrop(oldArray => [...oldArray, element.id]);
                });   
            }
        },[isToken, validData])
    
    const fetchTokenData = useCallback(async()=>{
        if (address !== null && address !== undefined && address.trim() !== '') {
            $('.ajax-loader').css("display", "flex");
            filterAirdropData();
            const tokenAbiDetails = await fetchTokenABI(currencyDetails.endPoint, token);
            if(!tokenAbiDetails){
                $('.ajax-loader').css("display", "none");
                swal("Failed to load contract abi", { buttons: false, icon: "error", timer: 2000 });
            }else{
                setTokenABI(tokenAbiDetails)
                setRpcWeb3(currencyDetails.web3Obj)
                if(isToken){
                    const details = await fetchTokenDetails(currencyDetails.web3Obj, address, tokenAbiDetails, token)
                    if(details){
                        setWalletBal(details.walletBalance);
                        setTokenBal(details.tokenBalance);
                        setTokenDecimal(details.decimal);
                    }
                    $('.ajax-loader').css("display", "none");
                }
                $('.ajax-loader').css("display", "none");
            }
        }
    },[address, currencyDetails.endPoint, currencyDetails.web3Obj, filterAirdropData, isToken, token])

    const fetchTronTokenData = useCallback(async()=>{
        $('.ajax-loader').css("display", "flex");
        filterAirdropData();
        const contract = await window.tronWeb.contract().at(token);
        const balance = (await window.tronWeb.trx.getBalance(window.tronWeb.defaultAddress.base58)/10**6).toFixed(4)
        setWalletBal(balance)
        if(isToken){
            const decimal = await contract.decimals().call();
            setTokenBal((await contract.methods.balanceOf(address).call()/10**Number(decimal)));
            setTokenDecimal(decimal)
            $('.ajax-loader').css("display", "none");
        }
        $('.ajax-loader').css("display", "none");
    },[address, filterAirdropData, isToken, token])

    useEffect(() => {
        let isApiSubscribed = true;
        if(isApiSubscribed){
            if(currencyDetails.networkType === "TRON"){
                fetchTronTokenData()
            }else{
                fetchTokenData()
            }
        }

        return ()=>{
            isApiSubscribed = false;
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token, address, validData, currencyDetails, isToken, erc1155])


    const approveBal = async () => {
       const isApproved = await approveTokenBalance(currencyDetails, tokenABI, token, address, totalTokens);
       console.log(isApproved, "visApproved")
       if(isApproved === true){
        switchToLast();
       }   
    }

    const approveTronBal = async () => {
        const isApproved = await approveTronBalance(currencyDetails, token, address, totalTokens)
        console.log("chceh")
        if(isApproved === true){
            switchToLast();
        }        
    }

    const approveTronNft = async() => {
        const contract = await window.tronWeb.contract().at(token);
        let isOwner = false;
        Promise.all(nftsToDrop.map(async(item)=>{
            const ownerOf = await contract.ownerOf(item).call();
            if(ownerOf.toUpperCase() !== address.toUpperCase()){
                isOwner = false;
                return swal(`You are not owner of token id ${item}`,{ buttons: false, icon: "error", timer: 2000 });
            }else{
                isOwner = true
            }
        })).then(async()=>{
            if(isOwner){
                handleApproveTronNft(currencyDetails,token, address).then((isApproved)=>{
                    if(isApproved){
                        switchToLast();
                    }
                });
                
            }
        })

        
    }

    const approveNft = async() => {
        
        const web3 = currencyDetails.web3Obj;
        const contract = new web3.eth.Contract(tokenABI, token);
        let isOwner = false;
        Promise.all(nftsToDrop.map(async(item)=>{
            const ownerOf = await contract.methods.ownerOf(item).call();
            if(ownerOf.toUpperCase() !== address.toUpperCase()){
                isOwner = false;
                return swal(`You are not owner of token id ${item}`, { buttons: false, icon: "error", timer: 2000 });
            }else{
                isOwner = true
            }
        })).then(async()=>{
            if(isOwner){
                const isApproved = await handleApproveNft(currencyDetails, tokenABI, token, address);
                if(isApproved === true){
                    switchToLast();
                }
            }
        })

        
    }

    const approveTronNft1155 = async() => {
        const contract = await window.tronWeb.contract().at(token);
        let addArr = [];
        let NFTArr = [];
        let countArr = [];
        let isOwner = false;

        validData.map((item)=>{
            addArr.push(`${address}`);
            NFTArr.push(`${item.id}`);
            countArr.push(Number(item.count));    
        })
        const ownerOf = await contract.balanceOfBatch(addArr,NFTArr).call();
        ownerOf.map((item, i)=>{
            if(Number(ownerOf[i]) < Number(countArr[i])){
                isOwner = false;
                return swal(`You don't have enough count of NFT Id ${NFTArr[i]}`, { buttons: false, icon: "error", timer: 2000 });
            }else{
                return isOwner = true;
            } 
        }).then(async()=>{
            if(isOwner){
                const isApproved = await handleApproveTronNft(currencyDetails,token, address);
                if(isApproved === true){
                    switchToLast();
                }
            }
        })
    }

    const approveNft1155 = async() => {
        // const web3 = new Web3(Web3.givenProvider || pageDetails.rpcurl);
        const web3 = currencyDetails.web3Obj;
        const contract = new web3.eth.Contract(tokenABI, token);
        let addArr = [];
        let NFTArr = [];
        let countArr = [];
        let isOwner = false; 

        validData.map((item)=>{
            addArr.push(`${address}`);
            NFTArr.push(`${item.id}`);
            countArr.push(Number(item.count));    
        })

        const ownerOf = await contract.methods.balanceOfBatch(addArr,NFTArr).call();
        ownerOf.map((item, i)=>{
            if(Number(ownerOf[i]) < Number(countArr[i])){
                isOwner = false;
                return swal(`You don't have enough count of NFT Id ${NFTArr[i]}`, { buttons: false, icon: "error", timer: 2000 });
            }else{
                return isOwner = true;
            }
        }).then(async()=>{
            if(isOwner){
                const isApproved = handleApproveNft(currencyDetails, tokenABI, token, address);
                if(isApproved === true){
                    switchToLast();
                }
            }
        })
    }

    const switchToLast = () => {
        setShowLastStep(true)
        $(".tab-pane").hide();
        $("#step3").fadeIn(1000);
        $(".progressbar-dots").removeClass("active");
        $(".progressbar-dots:nth-child(3)").addClass("active");
    }

    const presentNFTToDrop = ()=>{
        if(nftsToDrop.length > 0){
            let display = ""
            nftsToDrop.map((item,index)=>{
                if(index < nftsToDrop.length-1){
                    display = display+item+","
                }else{
                    display = display+item+""
                }
            })
            return display
        }
        return null;
    }
    
    return (
        <>

            {!showLastStep ?
                <div className="tab-pane" id="step2">
                    <div className="tb2">
                        <div className="dg-er">
                            <div className="row">
                                <div className="col-md-6">
                                    <div className="sh-vv">
                                        <h4>{isToken ? totalTokens : presentNFTToDrop()}</h4>
                                        <p>{isToken ? "Total numbers of tokens to send" : "ID's to send"}</p>
                                    </div>
                                </div>
                                {isToken && <div className="col-md-6">
                                    <div className="sh-vv">
                                        <h4>{tokenBal}</h4>
                                        <p>Token balance</p>
                                    </div>
                                </div>}
                                <div className="col-md-6">
                                    <div className="sh-vv">
                                        <h4>{walletBal}</h4>
                                        <p>Wallet balance</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="listtb">
                            <h5><b>List of recipients</b></h5>
                            <ul className="listofadd">
                                {validData.map((item) => {
                                    
                                    return (
                                        <li key={item.address}>
                                            <p>{item.address.substr(0, 5)}....{item.address.substr(-5)}</p>
                                            <p>{isToken ? item.amount : item.id}</p>
                                            {erc1155 && <p>{item.count}</p>}
                                        </li>
                                    )
                                })
                                }
                            </ul>
                            <br />
                        </div>
                        <ul>
                            <li key="btn">
                                {isToken ? <button className="next-btn next-btn2" type="button" onClick={ currencyDetails.networkType === "TRON" ? approveTronBal :approveBal}>Approve</button>:
                                !erc1155 ? <button className="next-btn next-btn2" type="button" onClick={ currencyDetails.networkType === "TRON" ? approveTronNft : approveNft}>Approve</button> :
                                <button className="next-btn next-btn2" type="button" onClick={ currencyDetails.networkType === "TRON" ? approveTronNft1155 : approveNft1155}>Approve</button>}
                            </li>
                        </ul>
                    </div>
                    {isToken && totalTokens > tokenBal ? <div className="dangerCss">⚠ Not enough tokens. Please add funds to your token balance or use a smaller batch</div>:null}

                </div> : showLastStep && <ContainerStepThree isToken = {isToken} erc1155={erc1155} deflationary={deflationary} tokendecimal={tokendecimal} validData={validData} totalTokens={totalTokens} rpcWeb3={rpcWeb3} tokenContractAddress={token} />}
            
        </>
    )
}

export default ContainerStepTwo